import { Box, Button, Checkbox, Container, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Modal, Paper, Select, Stack, Tooltip, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { reformatPermissions } from "../hooks/reformatPermissions";
import RightsCheckbox from "../components/rightsCheckboxInput";
import { Await, defer, useFetcher, useLoaderData } from "react-router-dom";
import api from "../hooks/useApi";
import { Suspense, useState, useRef, useEffect } from "react";
import CenteredSpinner from "../components/centerVPspinner";
import ErrorBoundary from "../components/errorBoundary";
import { Autoform } from "../components/forms/autoform";
import jsonToFormData from "../hooks/jsonToFormData";
import { Cropper } from 'react-cropper'
import "cropperjs/dist/cropper.css";
import Rotate90DegreesCcwOutlinedIcon from '@mui/icons-material/Rotate90DegreesCcwOutlined';
import Rotate90DegreesCwOutlinedIcon from '@mui/icons-material/Rotate90DegreesCwOutlined';
import ChangeCircleOutlinedIcon from '@mui/icons-material/ChangeCircleOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import PageTitle from "../components/PageTitle";

const formName = 'HotelRates';

export async function loader({ request, params }) {
    const id = 33;
    //const returnPromise = api.get(`/api/user/show/${id}/`);
    //const form = api.get(`/api/CreateObjForms/${formName}/`)
    return defer({
        id
        //returnPromise, form
    })
}

export default function TestPage() {
    const formHook = useForm({defaultValues:{
        some:[1,2,3,4,5]
    }})
    return (
        <>
            <PageTitle title="Тестова сторінка" />
            <form method='post' onSubmit={formHook.handleSubmit((data)=>{})}>
                <input type='text' {...formHook.register('other')}/>
                <button type='submit'>asdas</button>
            </form>
        </>
    )
}
